import React, { useState, useRef, useMemo } from "react";
import ProjectsList from "./ProjectsList";
import ProjectImage from "./ProjectImage";
import { useFirebaseDatabaseRootData } from "../../context/FirebaseDatabaseRootDataContext";
import useSpotlightEffect from "../../hooks/useSpotlightEffect";
import "./ProjectN.css";

const ProjectN = ({ onProjectSelect }) => {
  const { rootData, rootDataLoading, rootDataError } =
    useFirebaseDatabaseRootData();
  const [hoveredProject, setHoveredProject] = useState(null);
  const containerRef = useRef(null);
  const spotlightRef = useRef(null);

  useSpotlightEffect(
    containerRef,
    spotlightRef,
    !!hoveredProject
  );
  const projects = useMemo(() => rootData?.projects || [], [rootData]);

  if (rootDataLoading) {
    return <div className="project-n-loading">Loading projects...</div>;
  }

  if (rootDataError) {
    return (
      <div className="project-n-error">
        Error loading projects: {rootDataError}. Please try again later.
      </div>
    );
  }

  if (!projects.length) {
    return <div className="project-n-no-data">No projects found.</div>;
  }

  return (
    <>
      <div ref={containerRef} className="project-n-container">
        <div ref={spotlightRef} className="project-n-spotlight" />

        <div className="project-list-image-container">
          <h2 className="projects-title">Projects</h2>

          <div className="project-list-wrapper">
            <ProjectsList
              projects={projects}
              hoveredProject={hoveredProject}
              setHoveredProject={setHoveredProject}
              onProjectSelect={onProjectSelect}
            />
          </div>
          {hoveredProject && (
            <div className="project-image-overlay">
              <ProjectImage
                project={projects.find((p) => p.id === hoveredProject)}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProjectN;
